import { useMemo } from 'react';
import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';
import Image from '../atoms/Image';
import type { Season } from '../../data/Seasons';
import { getSeasonImage } from '../../assets/Assets';

const Container = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
`;

const Icon = styled.div`
	color: ${(props) => props.theme.colors.black};
	height: 12vmin;
	min-width: 12vmin;
	position: relative;
	width: 12vmin;
`;

const Circle = styled.div`
	border: ${(props) => props.theme.borderWidth.season} dashed
		${(props) => props.theme.colors.darkBlue};
	border-radius: 35%;
	bottom: 4%;
	color: ${(props) => props.theme.colors.darkBlue};
	left: 4%;
	padding: 14%;
	position: absolute;
	right: 4%;
	top: 4%;
`;

const Details = styled.div`
	align-items: center;
	display: flex;
	flex: 1;
	margin-left: 0.4rem;
	max-width: 18vmin;
	width: 18vmin;
`;

export interface Props {
	season: Season;
	icon?: ReactNode;
}

const ConceptsBarItem: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { season, icon, children } = props;

	const seasonImage = useMemo(() => getSeasonImage(season), [season]);

	return (
		<Container>
			<Icon>
				<Circle>
					<Image src={seasonImage} width="100%" height="100%" />
				</Circle>
				{icon}
			</Icon>
			<Details>{children}</Details>
		</Container>
	);
};

export default ConceptsBarItem;
